import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f5a8bdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "alt"]

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Navigation, Pagination, Autoplay } from "swiper";
import { getGameFeatures } from "@/api/indexPC";
import { ref } from "vue";
import { GlobalState } from "@/pages/index/store";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  async setup(__props) {

let __temp: any, __restore: any

const store = useStore<GlobalState>();
let modules = [EffectCoverflow, Pagination, Navigation, Autoplay];
let navigation = {
  nextEl: ".game-features .swiper-button-next",
  prevEl: ".game-features .swiper-button-prev",
};

let result = (
  ([__temp,__restore] = _withAsyncContext(() => getGameFeatures())),
  __temp = await __temp,
  __restore(),
  __temp
);
let gameFeaturesList = ref<any[]>([]);
gameFeaturesList.value = result.data;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "game-features",
    id: "game_features",
    style: _normalizeStyle({
      backgroundImage:
        'url(' + _unref(store)?.state?.imageObj?.backg?.feature?.pc + ')',
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(store)?.state?.imageObj?.title?.feature?.pc,
        alt: "游戏特色"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "swiper-box",
      style: _normalizeStyle({
        backgroundImage:
          'url(' + _unref(store)?.state?.imageObj?.border?.feature?.pc + ')',
      })
    }, [
      _createVNode(_unref(Swiper), {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 0,
          stretch: 100,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        pagination: false,
        navigation: _unref(navigation),
        modules: _unref(modules),
        class: "game-features-swiper",
        loop: "",
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameFeaturesList), (item) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: item?.img,
                  alt: item?.name
                }, null, 8, _hoisted_3)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["navigation", "modules"]),
      _createElementVNode("div", {
        class: "swiper-button-prev",
        style: _normalizeStyle({
          backgroundImage:
            'url(' + _unref(store)?.state?.imageObj?.ico?.feature?.l?.pc + ')',
        })
      }, null, 4),
      _createElementVNode("div", {
        class: "swiper-button-next",
        style: _normalizeStyle({
          backgroundImage:
            'url(' + _unref(store)?.state?.imageObj?.ico?.feature?.r?.pc + ')',
        })
      }, null, 4)
    ], 4)
  ], 4))
}
}

})